module.exports = __webpack_public_path__ + "static/pexels1-636ec88a2dcdf12dee98f446aa828061.png";